/**
 * Print Button Component
 * Handles printing of product specification sheets
 */

class PrintButton {
  constructor() {
    this.init();
  }

  init() {
    const printButtons = document.querySelectorAll('.spec-print-button');
    
    printButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handlePrint();
      });
      
      // Make elements keyboard accessible
      if (!button.hasAttribute('role')) {
        button.setAttribute('role', 'button');
      }
      if (!button.hasAttribute('tabindex')) {
        button.setAttribute('tabindex', '0');
      }
      
      // Handle keyboard activation (Enter and Space)
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          this.handlePrint();
        }
      });
      
      // Add pointer cursor for non-button elements
      if (button.tagName !== 'BUTTON') {
        button.style.cursor = 'pointer';
      }
    });
  }

  handlePrint() {

    // Safari renders print layout relative to scroll position — scroll to top first
    const savedScrollY = window.scrollY;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari && savedScrollY > 0) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
    
    // Small delay to ensure DOM updates before print dialog
    setTimeout(() => {
      window.print();
    }, 50);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PrintButton();
  });
} else {
  new PrintButton();
}
